import { render, staticRenderFns } from "./inboundHistory.vue?vue&type=template&id=391106c0&scoped=true&"
import script from "./inboundHistory.vue?vue&type=script&lang=js&"
export * from "./inboundHistory.vue?vue&type=script&lang=js&"
import style0 from "./inboundHistory.vue?vue&type=style&index=0&id=391106c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391106c0",
  null
  
)

export default component.exports